<div class="wrapper">
  <div class="circle">
    <smw-icon [icon]="isOn() ? onIcon : offIcon" />
  </div>
</div>
@if (expanded()) {
  <div class="button-m caption-md"><ng-content /></div>
}
